import is from '@sindresorhus/is';
/**
 * @name toString
 * @description Converts a value into a string
 * @param {any} value The value to convert
 * @returns {string} The converted value into a string
 *
 * @example
 * import {toString} from 'gso-utilities';
 * const myValue = 15;
 * const myString = toString(myValue);
 * console.log(myString); // '15'
 */
function toString(value) {
    return is.string(value) ? value : String(value);
}
export { toString };
//# sourceMappingURL=to-string.js.map